import { useCallback } from 'react';
import { ApiError } from './client';

export type ErrorInput = ApiError | Error | { message?: string } | string | null | undefined;

const stripErrorIdSuffix = (message: string): string =>
  message.replace(/\s*\(Error ID: [^)]+\)/gi, '').trim();

export const getErrorMessage = (err: unknown): string => {
  if (!err) return 'Unknown error';
  if (err instanceof ApiError) {
    return stripErrorIdSuffix(err.message);
  }
  if (err instanceof Error) return stripErrorIdSuffix(err.message);
  if (typeof err === 'string') return stripErrorIdSuffix(err);
  if (typeof err === 'number' || typeof err === 'boolean') return String(err);
  if (typeof err === 'object' && 'message' in err) {
    const message = (err as { message?: unknown }).message;
    if (typeof message === 'string') return stripErrorIdSuffix(message);
  }
  try {
    return JSON.stringify(err);
  } catch {
    return 'Unknown error';
  }
};

export const useApiErrorMessage = (): ((err: unknown) => string) =>
  useCallback((err: unknown): string => getErrorMessage(err), []);
